import ajaxNotification from '../../services/ajax-notification-service';
import logoutInterceptorService from '../../config/common/logout-interceptor.service';
import otpDirektLogin from './otp-direkt-login/index';
import smsVerification from './sms-verification/index';
import serviceNotAvailable from './service-not-available/index';
import direktLoginError from './direkt-login-error/index';
import downloadStatement from './download-statement/index';
import optenSearch from './opten-search/index';
import ebizTagsInput from './tags-input/tags-input';
import sendEmailForm from './send-email/send-email';
import {CouponCodeComponent} from "./coupon-code/coupon-code-component";
import CouponCodeService from "./coupon-code/coupon-code-service";
import contractsComponent from '../contracts/contracts.component';
import bankSecrecyDeclarationModal from './bank-secrecy-declaration-modal/bank-secrecy-declaration-modal';
/**
 * Bármely oldalon használható komponensek gyűjteménye
 * @author laci on 2016.10.24.
 */

export default function (app) {
	app
		.component('couponCode', CouponCodeComponent)
		.service('CouponCodeService', CouponCodeService);
	otpDirektLogin(app);
	smsVerification(app);
	optenSearch(app);
	direktLoginError(app);
	ajaxNotification(app);
	downloadStatement(app);
	serviceNotAvailable(app);
	ebizTagsInput(app);
	sendEmailForm(app);
	logoutInterceptorService(app);
	contractsComponent(app);
	bankSecrecyDeclarationModal(app);

}
